// Mirrors REASON_MAX_LENGTH in server/feedback/models.py. The server rejects
// anything longer with a 422, so the input stops typing at the same point
// rather than letting a note be composed that cannot be saved.
export const REASON_MAX_LENGTH = 280;

export interface FeedbackResponseOption {
  value: string;
  label: string;
  description?: string;
  aria_label?: string;
}

export interface FeedbackSource {
  source_id: string;
  name: string;
  description?: string;
  prompt?: string;
  response_options: FeedbackResponseOption[];
  supports_export: boolean;
  supports_note_only?: boolean;
}

/** What a row is about: one thing, the run of items under it, or a whole batch. */
export type FeedbackScope = "item" | "group" | "batch";

export interface FeedbackItem {
  source_id: string;
  batch_id?: string;
  item_id: string;
  entity_id?: string;
  scope?: FeedbackScope;
  title: string;
  subtitle?: string;
  detail?: string;
  /** Short status for the row itself, shown beside its title. */
  badge?: string;
  url?: string;
  prompt?: string;
  presentation_order: number;
  response_options: FeedbackResponseOption[];
  current_response?: string;
  current_reason?: string;
}

/** Whether a row takes a verdict. A heading takes only a note. */
export function isRateable(item: FeedbackItem): boolean {
  return item.response_options.length > 0;
}

export interface FeedbackQueue {
  source_id: string;
  batch_id?: string;
  items: FeedbackItem[];
}

export function feedbackItemKey(item: Pick<FeedbackItem, "source_id" | "item_id">): string {
  return JSON.stringify([item.source_id, item.item_id]);
}
